class SessionTokenService {
	private token = '';

	constructor(token: string) {
		this.token = token;
	}

	getLocalAccessToken(): string | null {
		return sessionStorage.getItem(this.token);
	}

	setLocalAccessToken(value: string): void {
		sessionStorage.setItem(this.token, value);
	}

	removeToken(): void {
		sessionStorage.removeItem(this.token);
	}
}

export default SessionTokenService;
